import { useMemo } from 'react';
import { useSelector } from '../context/Redux';
import { getTasksByIdsSelector } from '../redux/selectors/tasks';
export function useTasks(taskIds) {
  const getTasksByIds = useSelector(getTasksByIdsSelector);
  const tasks = useMemo(() => getTasksByIds(taskIds), [getTasksByIds, taskIds]);
  return tasks;
}